// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2568 ? "locales-web-ru-po-json" : chunkId) + "." + {"1274":"2d0eed5d40f607009dfa","2107":"8956afb0562a25da11af","2568":"b5d3e4f5271512c9f093"}[chunkId] + ".js";
};